import {useIntl} from 'react-intl'

const Bitrix24LineHeader = () => {
  const intl = useIntl()

  return (
    <thead>
      <tr className='fs-9 text-center'>
        <th role='columnheader' className='min-w-150px'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.LINE'})}
        </th>
        <th role='columnheader' className='min-w-140px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.DESCRIPTION'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.USERID'})}
        </th>
        <th role='columnheader' className='min-w-85px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.SMARTCALL'})}
        </th>
        <th role='columnheader' className='min-w-150px px-0 required'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.MANAGERTIME'})}
        </th>
        <th role='columnheader' className='min-w-150px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.SMARTCALLBYTIME'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.AUTOLEAD'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.TOCHAT'})}
        </th>
        <th role='columnheader' className='min-w-100px px-0'>
          {intl.formatMessage({id: 'APPS.SETTINGS.BITRIX24.LINES.HEADER.EDIT'})}
        </th>
      </tr>
    </thead>
  )
}

export {Bitrix24LineHeader}
